<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddMechanicTimeCode</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>

      <form [formGroup]="addMechanicTimeCodeForm" (ngSubmit)="onSubmit()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6 af-form-group">
                  <label for="typeahead-format"><span translate>lblSelectDealer</span>
                    <span class="text-danger"> * </span> </label>
                  <div class="lbl-info font-size12">

                    <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dealerList"
                      (ngModelChange)="onDropdownDealerSelected($event)" [(ngModel)]="selectedDealer" formControlName="dealerId">
                    </ng-multiselect-dropdown>

                  </div>
                </div>
                <div class="w-100 col-12" *ngIf="t">
                  <div *ngFor="let ticket of t.controls; let i = index">
                    <div class="form-row" [formGroup]="ticket">
                      <div class="col-6 af-form-group">
                          <label for="name" translate>lblTimeCode <span>in {{languageList[i].value}}</span>
                            <strong class="mlt6 required"> * </strong></label>
                        <div class="lbl-info">
                          <input formControlName="name"  class="form-control mb-2" maxlength="50">
                          <div *ngIf="cpf.service.touched && cpf.service.invalid" class="help-block mt-1 text-danger"> 
                            <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                            translate>lblNameRequired</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-6 af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                            maxlength="30">
                        </div>
                      </div>

                      <div class="col-6 af-form-group">
                        <label for="description"><span translate>lblDescription</span><span>&nbsp;<span
                              translate>lblIn</span>
                            {{languageList[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" maxlength="500">
                          <div *ngIf="cpf.service.touched && cpf.service.invalid" class="help-block mt-1 text-danger">
                             <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                             translate>lblDescriptionRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 af-form-group">
                  <div class='lbl-info ml-2'>
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="IsShow" formControlName="IsShow">
                      <label class="custom-control-label" for="IsShow" translate>lblDisplayInDWO</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" translate
                [disabled]="!addMechanicTimeCodeForm.valid">
                <em class="fa fa-plus font16 align-top mr-2"></em>
                lblAdd
              </button>
              <a (click)="OnClose()" type="reset" class="btn btn-lg btn-secondary" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>